module.exports = __webpack_public_path__ + "static/media/arrowUpBlack.8cf76458.svg";